import { on } from 'events'
import React, { FC } from 'react'


type Props = {
    placeholder?: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    className?: string;
    disabled?: boolean;
    name?: string;
    error?: boolean;

} & React.InputHTMLAttributes<HTMLInputElement>

const CheckBox: FC<Props> = ({
    placeholder,
    checked,
    onChange,
    onBlur,
    className,
    disabled,
    name,
    error,
    ...props
}) => {
    return (
        <input
            type="checkbox"
            checked={checked}
            onChange={(e)=>onChange(e)}
            name={name}
            className={className ? className : 'policy-input'}
            placeholder={placeholder ? placeholder : ''}
            onBlur={onBlur ? (e) => onBlur!(e) : undefined}
            disabled={disabled ? disabled : false}
            {...props}
        />
    )
}

export default CheckBox